export const API_BASE_URL = "https://manejard.com";

export const WHATSAPP_NUMBER = "18299064722";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const WHATSAPP_APPOINTMENT_CONFIRMATION = true;

export const CONTACT_INFO = {
  phone: "(829) 906-4722",
  phoneRaw: "+18299064722",
  email: "info@manejard.com",
  hours: {
    weekdays: "8:00 AM - 6:00 PM",
    saturday: "8:00 AM - 4:00 PM",
    sunday: "Cerrado",
  },
};

export const LOCATIONS = [
  {
    city: "Santo Domingo",
    address: "C. Rafael J Castillo 88, Santo Domingo 10510",
    details: "Entre Americo Lugo y Arturio Loroño, Ensanche La Fe",
  },
  {
    city: "Nagua",
    address: "Calle Duarte, Plaza Alemán Victoria",
    details: "Ciudad de Nagua",
  },
  {
    city: "Santiago Rodríguez",
    address: "Calle Duarte, Villa Los Almacigos",
    details: "Próximo a la Plaza de la Bandera",
  },
];

export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/manejadr",
  instagram: "https://instagram.com/manejadr",
  whatsapp: WHATSAPP_URL,
};

export const APP_NAME = "ManejaRD";
export const APP_TAGLINE = "ESCUELA de Chofers";
export const APP_DESCRIPTION =
  "Cursos intensivos para aprender a conducir en República Dominicana";
